import { Component, OnInit, Inject } from '@angular/core';
import { ProfileService } from 'app/profile/services/profile.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToolParameter, ToolParameterType } from 'app/profile/models/generic.model';
import { Observable } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TslDialog } from '@tesla/ng-tds';
import { I18nService } from 'app/shared/services/i18n.service';

@Component({
	selector: 'app-parameter-form-dialog',
	templateUrl: './parameter-form-dialog.component.html',
	styleUrls: ['./parameter-form-dialog.component.scss']
})
export class ParameterFormDialogComponent implements OnInit {
	obParameterTypes$: Observable<ToolParameterType[]>;
	paramGroup: FormGroup;

	get paramValue() { return this.paramGroup.get('paramValue'); }

	constructor(
		private fb: FormBuilder,
		private service: ProfileService,
		public translate: I18nService,
		public dialogRef: MatDialogRef<ParameterFormDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data:
			{
				supplierCode: string,
				subCategoryId: number,
				param: ToolParameter
			},
		private dialog: TslDialog) {
		this.paramGroup = this.fb.group({
			paramValue: ['', Validators.required]
		});
	}

	ngOnInit() {
		this.loadResources();

		this.paramGroup.patchValue({
			paramType: this.data.param.typeId,
			paramValue: this.data.param.value
		});
	}

	onClose(): void {
		this.dialogRef.close();
	}

	onSave(): void {
		if (this.paramGroup.invalid) {
			return;
		}
		this.data.param.value = this.paramGroup.value.paramValue;
		this.dialogRef.close(this.data.param);

	}

	private loadResources(): void {
		this.obParameterTypes$ = this.service.getParameterType(this.data.supplierCode, this.data.subCategoryId);
	}
}
